<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Events</div>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="eventsLoading"
                @click="handleRefresh()"
              >
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                unelevated
                no-caps
                @click="downloadCSV"
              >
                <q-icon
                  name="mdi-download"
                  color="accent"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Download CSV
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondary"
                unelevated
                text-color="accent"
                no-caps
                @click="openMultiple"
                :label="$q.screen.gt.sm ? 'View Selected' : ''"
                icon="mdi-eye"
              >
                <!-- <q-icon size="xs" name="mdi-eye" class="q-mr-sm"></q-icon>
                View Selected -->
              </q-btn>

              <q-btn
                v-if="$q.screen.gt.sm"
                class="q-ml-md"
                color="secondary"
                unelevated
                text-color="accent"
                no-caps
                :loading="eventsLoading"
              >
                <q-icon size="xs" name="mdi-calendar" class="q-mr-sm"></q-icon>
                Date Range
                <q-menu
                  :anchor="'bottom left'"
                  :self="`${$q.screen.lt.sm ? 'top middle' : 'top left'}`"
                >
                  <div class="row wrap q-pa-xs">
                    <div class="column" v-if="$q.screen.gt.sm" style="min-width: 140px">
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('today')"
                      >
                        Today
                      </q-btn>
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('yesterday')"
                      >
                        Yesterday
                      </q-btn>
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('thisWeek')"
                        >This Week</q-btn
                      >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('lastWeek')"
                        >Last Week</q-btn
                      >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('lastTwoWeeks')"
                        >Last Two Weeks</q-btn
                      >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('thisMonth')"
                        >This Month</q-btn
                      >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('lastMonth')"
                        >Last Month</q-btn
                      >
                    </div>

                    <q-separator v-if="$q.screen.gt.sm" vertical inset class="q-mx-sm" />

                    <div class="column items-center" @click="selectedRelativeDate = null">
                      <vc-date-picker
                        id="datePicker"
                        v-model="proxyDate"
                        :model-config="modelConfig"
                        is-range
                        :columns="$screens({ default: 1, xl: 2 })"
                        ref="datePicker2"
                      >
                        <!-- <template
                          v-slot="{ inputValue, inputEvents, updateValue }"
                        >
                          <button @click="updateValue(getDateRange())" />
                        </template> -->
                      </vc-date-picker>
                    </div>
                  </div>
                </q-menu>
              </q-btn>

              <span v-if="$q.screen.gt.sm" class="q-ml-sm dateRangeText">
                {{ dateRange.from }} ~ {{ dateRange.to }}
              </span>

              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-calendar"
                v-if="$q.screen.lt.md"
                @click="dateRangeDialog = true"
              >
              </q-btn>

              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="events">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 160px) !important"
                >
                  <datatable
                    ref="dataTable"
                    :filter="search"
                    :flat="true"
                    :data="events"
                    :columns="columns"
                    selection="multiple"
                    @rowDoubleClick="handleDoubleClick"
                  >
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px; height: 90vh"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Event{{ viewFormData.id != undefined ? ` # ${viewFormData.id}` : "s" }}
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-scroll-area style="height: calc(90vh - 60px)">
          <q-card-section>
            <eventForm
              ref="editForm"
              :data="viewFormData"
              @close="viewDetailsDialog = false"
              @loadingStateChanged="(state) => (saveLoading = state)"
            />
          </q-card-section>
          <q-card-section> </q-card-section>
        </q-scroll-area>
      </q-card>
    </q-dialog>
    <q-dialog v-model="dateRangeDialog" max-width="600px">
      <q-card
        class="dateRangeDialog"
        v-if="dateRangeDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Please select your range
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="dateRangeDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <div class="col-6 q-px-sm">
              <q-input
                filled
                label="From"
                v-model="proxyDate.start"
                mask="date"
                :rules="['date']"
              >
                <template>
                  <q-popup-proxy
                    ref="qDateProxy"
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="proxyDate.start">
                      <div class="row items-center justify-end">
                        <q-btn v-close-popup label="Close" color="primary" flat />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </template>
              </q-input>
            </div>
            <div class="col-6 q-px-sm">
              <q-input
                label="To"
                filled
                v-model="proxyDate.end"
                mask="date"
                :rules="['date']"
              >
                <template>
                  <q-popup-proxy
                    ref="qDateProxy"
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="proxyDate.end">
                      <div class="row items-center justify-end">
                        <q-btn v-close-popup label="Close" color="primary" flat />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </template>
              </q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="
                  save();
                  dateRangeDialog = false;
                "
                color="primary"
                no-caps
                class="float-right"
              >
                <!-- <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon> -->
                Apply
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import eventForm from "@/components/events/eventForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    eventForm,
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      events: "events/list",
      eventsLoading: "events/listLoading",
      dateRange: "settings/dateRange",
    }),
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "id",
        label: "Event ID",
        align: "left",
        field: "id",
        sortable: true,
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "device_id",
        label: "Device ID",
        align: "left",
        field: "device_id",
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "type",
        label: "Type",
        align: "left",
        field: "type",
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "sessions",
        label: "Sessions",
        align: "left",
        field: "sessions",
        sortable: true,
        style:
          "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "triggers",
        label: "Trigger Count",
        align: "left",
        field: "triggers",
        sortable: true,
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "version",
        label: "Version",
        align: "left",
        field: "version",
        sortable: true,
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "battery",
        label: "Battery level",
        align: "left",
        field: "battery",
        sortable: true,
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "temp",
        label: "Temperature",
        align: "left",
        field: "temp",
        sortable: true,
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "created_at",
        label: "Server upload time",
        align: "left",
        field: "created_at",
        format: (val) =>
          val != null ? moment.utc(val).local().format("DD-MMM, YYYY h:mma") : "",
        sortable: true,
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "created_at2",
        label: "Event origin time",
        align: "left",
        field: "invalidDeviceTime",
        format: (val) =>
          val != null ? moment.utc(val).local().format("DD-MMM, YYYY h:mma") : "",
        sortable: true,
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "message",
        label: "Message",
        align: "left",
        field: "message",
        sortable: true,
        style:
          "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },

      {
        name: "ai_prediction",
        label: "Prediction",
        align: "left",
        field: "ai_prediction",
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },

      {
        name: "ai_certainty",
        label: "Certainty",
        align: "left",
        field: "ai_certainty",
        sortable: true,
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "lat/long",
        label: "Location",
        align: "left",
        field: "lat",
        sortable: true,
        style:
          "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        format: (val, row) => {
          return row.lat || row.long ? `${row.lat}, ${row.long}` : "";
        },
      },
      {
        name: "rb_valid",
        label: "Rock Block Valid",
        align: "left",
        field: "rb_valid",
        format: (val) => (val != null ? (val == 1 ? "True" : "False") : ""),
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "rb_unitType",
        label: "Rock Block Unit Type",
        align: "left",
        field: "rb_unitType",
        sortable: true,
        format: (val) => {
          switch (val) {
            case 1:
              return "Trap";
            case 2:
              return "CritterPic";
            case 3:
              return "Relay";
            default:
              return "";
          }
        },
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "rb_status",
        label: "Rock Block Status",
        align: "left",
        field: "rb_status",
        format: (val) => {
          switch (val) {
            case 0:
              return "Normal";
            default:
              return val;
          }
        },
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "rb_data",
        label: "Rock Block Data",
        align: "left",
        field: "rb_data",
        format: (val, row) => {
          if (row.rb_unitType == 1) {
            switch (val) {
              case 0:
                return "Untriggered";
              case 1:
                return "Trap 2 triggered";
              case 2:
                return "Trap 1 triggered";
              case 3:
                return "All traps triggered";
              default:
                return val;
            }
          } else {
            return val;
          }
        },
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "rb_extendedData",
        label: "Rock Block Extended Data",
        align: "left",
        field: "rb_extendedData",
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
    ],
    search: "",

    proxyDate: {
      start: new Date(),
      end: new Date(),
    },
    startingProxyDate: null,
    endingProxyDate: null,

    viewFormData: null,
    viewDetailsDialog: false,

    dateRangeDialog: false,
    modelConfig: {
      start: {
        timeAdjust: "00:00:00",
      },
      end: {
        timeAdjust: "23:59:59",
      },
    },
    selectedRelativeDate: "lastTwoWeeks",
  }),
  watch: {
    proxyDate: function () {
      this.save();
    },
  },
  beforeCreate() {
    this.$store.dispatch("events/loadAll");
  },
  mounted() {
    this.$nextTick(() => {
      this.proxyDate = {
        start: moment(this.dateRange.from).startOf("day").toDate(),
        end: moment(this.dateRange.to).endOf("day").toDate(),
      };
    });
  },
  methods: {
    handleDoubleClick(row) {
      this.viewFormData = row;
      this.viewDetailsDialog = true;
    },
    openMultiple() {
      this.viewFormData = this.$refs.dataTable.selected;
      this.viewDetailsDialog = true;
    },
    save() {
      let date = {
        from: moment(this.proxyDate.start).format("YYYY/MM/DD"),
        to: moment(this.proxyDate.end).format("YYYY/MM/DD"),
      };
      this.$store.dispatch("settings/loadDateRange", date);
    },
    handleRelativeDate(range) {
      let start = new Date();
      let end = new Date();
      switch (range) {
        case "yesterday":
          start.setDate(start.getDate() - 1);
          end.setDate(end.getDate() - 1);
          break;
        case "thisWeek":
          start = moment().startOf("week").toDate();
          break;
        case "lastWeek":
          start = moment().subtract(1, "weeks").startOf("week").toDate();
          end = moment().subtract(1, "weeks").endOf("week").toDate();
          break;
        case "lastTwoWeeks":
          start = moment().subtract(1, "weeks").startOf("week").toDate();
          break;
        case "thisMonth":
          start = moment().startOf("month").toDate();
          break;
        case "lastMonth":
          start = moment().subtract(1, "months").startOf("month").toDate();
          end = moment().subtract(1, "months").endOf("month").toDate();
          break;
        default:
          break;
      }

      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      this.proxyDate.start = start;
      this.proxyDate.end = end;
      try {
        this.$refs.datePicker2.updateValue(this.proxyDate);
      } catch (error) {}
    },
    handleRefresh() {
      if (this.selectedRelativeDate != null) {
        this.handleRelativeDate(this.selectedRelativeDate);
      }
      this.save();
    },
    downloadCSV() {
      let filename = "events.csv";

      let text = this.generateCSV(this.$refs.dataTable.selected);

      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    generateCSV(devices) {
      const csvString = [
        Object.keys(devices[0]),
        ...devices.map((item) => Object.values(item)),
      ]
        .map((e) => e.join(","))
        .join("\n");

      return csvString;
    },
  },
};
</script>

<style scoped lang="scss">
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.dateRangeText {
  font-size: 10pt;
  color: $accent;
}
</style>
